var url = {
    isTest: process.env.NODE_ENV === 'development',
    getHost: function () {
        if (this.isTest)
            return 'localhost:50000';
        return 'manage.hbnuozhu.com';
        // return 'localhost:50000';
        // return `http://${this.getHost()}`;
    },
    getDomain: function () {
        if (this.isTest)
            return `http://${this.getHost()}`;
        return `http://${this.getHost()}`;
    },
    getDomainFront: function () {
        if (this.isTest)
            return 'localhost:60000';
        return 'http://www.hbnuozhu.com';
    },
    getController: function (controller, action) {
        if (action)
            return `${this.getDomain()}/${controller}/${action}`;
        else
            return `${this.getDomain()}/${controller}`;
    },
    //UE服务端接口
    getUE: function () {
        return this.getController('api/ueditor');
    },
    //UE配置地址
    getUEConfig: function () {
        if (this.isTest)
            return '/UEditor/';
        return '/vue/UEditor/';
    },
    //统一上传地址
    getUpload: function () {
        return "ws://" + this.getHost() + "/upload/common";
    },
    //用户账户操作
    getAccount(str) {
        return this.getController('api/account', str);
    },
    //系统操作
    getSys(str) {
        return this.getController('api/sys', str);
    },
    //栏目
    getColumn(str) {
        return this.getController('api/column', str);
    },
    //栏目
    getSiteInfo(str) {
        return this.getController('api/siteinfo', str);
    },
    //文章操作
    getArticle(str) {
        return this.getController('api/article', str);
    },
    //产品
    getProduct(str) {
        return this.getController('api/product', str);
    },
    //产品图集
    getProductImage(str) {
        return this.getController('api/productimage', str);
    },
    //产品类型
    getProductType(str) {
        return this.getController('api/producttype', str);
    },
    //banner管理
    getBanner(str) {
        return this.getController('api/banner', str);
    },
    //友情链接管理
    getFriendLink(str) {
        return this.getController('api/friendlink', str);
    },
}
export default url;